import * as axios from 'axios';
import {
    getEnv,
    getPokeUser,
    getH5ParametersDict,
    getH5Parameters,
    createRequestId,
    isIos,
    isNative,
    format
} from './utils.js';
import { bridge } from './bridge.js';
import { DataStruct } from './DataStruct.js';
import { Performance } from './Performance.js';
import { reportException } from './monitor.js';
import { BOM } from './BOM.js';

const apiBlockCollection = {
    '/x/mv/info': '/x/mv/simple_info'
};
const _env = getEnv();
const pokeUser = getPokeUser();
const isTestEnv = window.location.host.indexOf('test.pokekara.com') != -1;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 90000;
const CancelToken = axios.CancelToken;
const defaultcancelRefer = {};//用于请求的取消
const Error = {
    EVENT: 'web_network_error',
    LOCALNETWORKERROR: 'local_network',
    SERVERRESPONSEERROR: 'server_response',
    HTTPERROR: 'server_response_http',
    JSONERROR: 'server_response_json_format',
    USERERROR: 'local_callback',
    MSG: 'サイバーとの接続が切られましたので、もう一度ログインしてお試しください',
    LOCALMSG: 'ネット環境が不安定です、あとでもう一度やり直してください。'
};

function _format(param) {
    let s = [];
    for (let j in param) {
        s.push(encodeURIComponent(j) + '=' + encodeURIComponent(param[j]));
    }
    let result = s.join('&').replace(/%20/g, '+');
    return result === '' ? result : '&' + result;
}

const _parametersDict = getH5ParametersDict();
const _parameters = getH5Parameters();
//存储每个请求允许请求次数的信息
const _request_store = {};

//本地网络错误处理
function wrapLocalNetWorkError(key, originOptions, options, e) {
    let _cache = _request_store[key];
    //重试
    if (_cache.count != 0 && options.needRetry) {
        _cache.count--;
        originOptions.key = key;
        //10秒钟后重试
        setTimeout(function() {
            _request(originOptions);
        }, 10000);
    } else {
        _request_store[key] = null;
        options.error(2, { response: { data: { err_code: 0, err_msg: Error.LOCALMSG } } }); //local network error
        //网络错误回调
        options.netWorkErrorCallback();
        if (options.log) {
            _log({
                label: Error.LOCALNETWORKERROR,
                extra: {
                    api: originOptions.url,
                    content: (e && e.code) || 'weak_lan'
                }
            });
        }
    }
}

//
function _log(data) {
    data && (data.type = 'error') && (data.event = Error.EVENT);
    setTimeout(() => {
        Performance.log(data);
    }, 3000);
}

function isDebug() {
    return isIos() && pokeUser.is_debug;
}

function debugResponse(url, response) {
    if (isDebug()) {
        //response 上报给客户端，用于测试抓包
        bridge.post('debug_api_response', {
            url: url,
            response: response
        });
    }
}

function debugRequest(url) {
    if (isDebug()) {
        //request 上报给客户端，用于测试抓包
        bridge.post('debug_api_request', {
            url: url
        });
    }
}

//服务端返回的格式
const responseFormat = {
    err_code: 0,
    err_msg: '',
    data: {}
};

//回调
function wrapCallBack(option, api, response, cb) {
    if (response.data instanceof Object) {
        //是否需要约束,如果添加约束，则会根据约束返回值
        //假设q:{ 'a':0,'b':0,'c':0 } 实际server 的返回值为 { 'a':1,'b':1 } 则实际返给调用函数的值为 { 'a':1,'b':1,'c':0 }
        if (option.q) {
            const _q = {
                ...responseFormat,
                data: option.q
            };
            cb(DataStruct.extend(response.data, _q));
        } else {
            cb(response.data);
        }
        //err_code不为0 进行上报
        if (response.data.err_code && option.log) {
            _log({
                label: Error.SERVERRESPONSEERROR,
                extra: {
                    content: response.data.err_msg,
                    api: api
                }
            });
        }
    } else {
        //说明服务端返回的非json的数据，上报
        if (option.log) {
            _log({
                label: Error.JSONERROR,
                extra: {
                    content: response.data,
                    api: api
                }
            });
            BOM.alert(Error.MSG);
        }
    }
}

//http error 处理 (http code 不为 200)
function wrapHttpError(e, option, o_option, key, cb) {
    if (e.response) {
        if (e.response.data && e.response.data instanceof Object) {
            //走正常的callback流程，callback要对 err_msg 进行处理
            cb(e.response.data);
        } else {
            //http 异常 加 非json格式
            option.error(1, e, option);
        }
        if (option.log) {
            _log({
                label: Error.HTTPERROR,
                extra: {
                    api: o_option.url,
                    content: e.response.status || 200,
                    msg: e.response.data || ''
                }
            });
        }
    } else {
        //没有response 代表服务端没有返回，超时或者是本地网络错误或者跨域限制
        if (option.needNetworkError) {
            wrapLocalNetWorkError(key, o_option, option, e);
        }
    }
}

//回调函数里的异常,直接上报
function wrapUserError(e, option, api) {
    //回调函数异常
    option.error(3, e, option);
    if (option.log) {
        reportException(e, api);
    }
}

//
function _request(options, cancelRefer) {
    if (!options.url) {
        throw 'url required';
    }
    const _cancelRefer = cancelRefer || defaultcancelRefer;
    let _options = {
        proxy: false, //是否启用客户端代理
        proxyBaseUrl: '',
        headers: {},
        mark: {},
        encrypted: false, //是否需要加密发送
        gzip: false,
        method: 'get',
        crossOrigin: true,
        json: false,
        q: null, //如果有传入json,用来约束返回数据的格式
        log: true, //异常时是否发送log
        needRetry: true, //网络错误重试，为false仅处理一次
        needNetworkError: true, //为false 则不会处理网络错误
        netWorkErrorCallback: () => {
        },
        baseUrl: 'https://api.pokekara.com',
        env: _env || 'dev',
        callback: () => {
        },
        error: (status, e) => {
            //处理非业务的异常1 http 异常 加 非json格式  2 网络错误  3 业务
            if (e.response) {
                try {
                    if (e.response.data.err_msg) {
                        BOM.alert(e.response.data.err_msg);
                    } else {
                        //非json格式,直接输出，方便调试
                        BOM.log(e);
                        BOM.alert(Error.MSG);
                    }
                } catch (e) {
                    BOM.log(e);
                    BOM.alert(Error.MSG);
                }
            } else {
                //程序异常
                BOM.log(e);
                BOM.alert(Error.MSG);
            }
        },
        data: {},
        ...options
    };
    //请求端唯一标示
    const _key = _options.key || createRequestId();
    const urlArray = _options.url.split('?');
    const api = urlArray[0];
    const params = urlArray[1];
    const proxyApi = apiBlockCollection[api];
    //const needQ_sign = !!proxyApi;
    const needQ_sign =false;
    //启用客户端代理
    if (needQ_sign || _options.proxy) {
        if (isNative() && pokeUser.allows_native_request) {
            const _init = {
                method: _options.method,
                data: { ..._options.data },
                timeout: axios.defaults.timeout / 1000,
                headers: _options.headers,
                gzip: _options.gzip,
                mark: _options.mark
            };
            if (_options.json) {
                _init.encoding = 'json';
            }
            if (_options.needRetry) {
                _init.retry = 3;
            }
            if (_options.encrypted) {
                _init.mark.hash_type = 1;
            }
            _cancelRefer['cancel'] = () => {
                bridge.post('cancel_request', { id: _key });
            };
            _options.url =
                _options.url.indexOf('?') === -1
                    ? _options.url + '?request_refer=native_proxy'
                    : _options.url + '&request_refer=native_proxy';
            const _pdata = {
                init: _init,
                id: _key
            };
            if (_options.proxyBaseUrl) {
                _pdata.url = _options.proxyBaseUrl + _options.url;
            } else {
                _pdata.api_path = _options.url;
            }
            bridge.post(
                'request',
                {
                    ..._pdata
                },
                (parameters, error) => {
                    if (error) {
                        BOM.alert(error.code);
                        return;
                    }
                    const data = parameters.json;
                    //
                    if (data instanceof Object) {
                        if (_options.q) {
                            const _q = {
                                ...responseFormat,
                                data: _options.q
                            };
                            _options.callback(DataStruct.extend(data, _q));
                        } else {
                            _options.callback(data);
                        }
                        if (data.err_code && _options.log) {
                            _log({
                                label: Error.SERVERRESPONSEERROR,
                                extra: {
                                    content: data.err_msg,
                                    api: options.url,
                                    native_proxy: 1
                                }
                            });
                        }
                    } else {
                        if (_options.log) {
                            _log({
                                label: Error.JSONERROR,
                                extra: {
                                    content: data,
                                    api: options.url,
                                    native_proxy: 1
                                }
                            });
                            BOM.alert(Error.MSG);
                        }
                    }
                }
            );
            return;
        } else {
            if (proxyApi) {
                _options.url = proxyApi + (params ? '?' + params : '');
            }
        }
    }
    const callback = data => {
        debugResponse(_options.url, data);
        _options.callback(data);
    };
    //去除重复参数，当data 里的参数 与 querystring 里的冲突时以data里为主
    let parameters = _parameters;
    if (_options.method.toLowerCase() === 'get') {
        if (Object.keys(_options.data).length != 0) {
            const paramDict = DataStruct.extend(_parametersDict);
            for (let o in _options.data) {
                paramDict[o] && delete paramDict[o];
            }
            parameters = format(paramDict);
        }
    }
    //初始化，每个请求额外三次机会
    !_options.key && (_request_store[_key] = { count: 3 });
    //添加key参数
    _options.url =
        _options.url.indexOf('?') === -1
            ? _options.url + '?request_id=' + _key
            : _options.url + '&request_id=' + _key;
    //判断是不是重试请求，如果是，将参数添加到参数上
    _options.retry && (_options.url = _options.url + '&retry=1');
    _options.url = _options.url + '&' + parameters;
    if ((_options.env === 'cdn' || isTestEnv) && _options.crossOrigin) {
        if (isTestEnv) {
            _options.baseUrl = 'http://test.api.pokekara.com';
        }
        _options.url = _options.baseUrl + _options.url;
    }
    debugRequest(_options.url);
    //发起请求
    if (_options.method.toLowerCase() === 'post') {
        let _postOption = {
            method: 'post',
            url: _options.url,
            data: _options.data,
            cancelToken: new CancelToken(function executor(c) {
                _cancelRefer['cancel'] = c;
            }),
            headers: _options.headers
        };
        if (!_options.json) {
            _postOption.transformRequest = [
                function(data) {
                    // 对 data 进行任意转换处理
                    return _format(data);
                }
            ];
            _postOption.headers['Content-Type'] =
                'application/x-www-form-urlencoded; charset=UTF-8';
        }
        if (pokeUser.poke_session_id) {
            _postOption.headers['x-poke-session-id'] = pokeUser.poke_session_id;
        }
        return axios(_postOption)
            .then(function(response) {
                try {
                    wrapCallBack(_options, options.url, response, callback);
                } catch (e) {
                    wrapUserError(e, _options, options.url);
                }
            })
            .catch(function(e) {
                wrapHttpError(e, _options, options, _key, callback);
            });
    } else {
        const headers = _options.headers;
        if (pokeUser.poke_session_id) {
            headers['x-poke-session-id'] = pokeUser.poke_session_id;
        }
        return axios
            .get(_options.url + _format(_options.data), {
                cancelToken: new CancelToken(function executor(c) {
                    _cancelRefer['cancel'] = c;
                }),
                headers: headers
            })
            .then(function(response) {
                try {
                    wrapCallBack(_options, options.url, response, callback);
                } catch (e) {
                    wrapUserError(e, _options, options.url);
                }
            })
            .catch(function(e) {
                wrapHttpError(e, _options, options, _key, callback);
            });
    }
}

export { _request as request, axios, defaultcancelRefer, Error };
